import { render } from "./browseNFTs.vue?vue&type=template&id=1336adc2&scoped=true"
import script from "./browseNFTs.vue?vue&type=script&lang=js"
export * from "./browseNFTs.vue?vue&type=script&lang=js"

import "./browseNFTs.vue?vue&type=style&index=0&id=1336adc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1336adc2"]])

export default __exports__